import { authPut } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { RepoChanges, SubmitDeploymentRepoResponse } from "@types";

import { Repo } from "@pages/projects/types";

export const submitDeploymentRepo = (
  deploymentId: string,
  repo: Repo,
  repoChanges: RepoChanges
) => {
  return authPut<RepoChanges, SubmitDeploymentRepoResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/repos/${repo.name}`,
    { ...repo, ...repoChanges }
  );
};
